export enum ComparationType {
	DoD = 1,
	WoW = 2,
	MoM = 3,
	YoY = 4,
}
